import type { SchemaOwner } from '@cli-types/preset-engine/presets.js'
import { loadSchemaOwnershipIndex } from './load-schema-ownership-index.js'
import { saveSchemaOwnershipIndex } from './save-schema-ownership-index.js'

export function setSchemaOwner(cwd: string, schemaName: string, owner: SchemaOwner): void {
  const index = loadSchemaOwnershipIndex(cwd)
  index.schemas[schemaName] = owner
  saveSchemaOwnershipIndex(cwd, index)
}
